import { Modal } from '@components/common/modal/modal';
import React, { useCallback, useState } from 'react';
import { AddFccCheckModal } from './FccModal';
import { overlayRemoveFadeAction } from '@components/common/sort';
import { useIsImpersonationLoginUser } from '../../../../authGuard/hooks/useIsImpersonationLoginUser';

export interface FCCDetailsSectionProps {
	membershipData: { number: string; name: string };
	refetchRequests?: () => void;
	isModalOpen?: boolean;
}

export const FCCDetailsSection: React.FC<FCCDetailsSectionProps> = (props) => {
	const { membershipData, refetchRequests, isModalOpen } = props;
	const [open, setOpen] = useState(isModalOpen ?? false);
	const isImpersonationLoginUser = useIsImpersonationLoginUser();

	const handleClose = useCallback(() => {
		overlayRemoveFadeAction(() => {
			setOpen(false);
		});
	}, []);

	return (
		<>
			{!isModalOpen && (
				<section className="fcc-status">
					<div className="container">
						<div className="fcc-status-inner">
							<button
								type="button"
								id="site-list-btn"
								aria-label="add-new-site-button"
								className="btn btn-secondary btn-small add-new-fcc-btn"
								value="add-new-site-button"
								onClick={() => setOpen(true)}
								disabled={isImpersonationLoginUser}
							>
								FPC Enrollment{' '}
								<span className="add-new-fcc-icon">
									<span className="icon-plus"></span>
								</span>
							</button>
						</div>
					</div>
				</section>
			)}

			{open && (
				<Modal
					modalTitle={'FCC Enrollment'}
					modalOpen={open}
					modalId={'fccEnrollmentForm'}
					onModalClose={handleClose}
					className="dialog-lg dialog-bottom p-0 pb-16"
				>
					<AddFccCheckModal
						onClose={() => {
							refetchRequests?.();
							handleClose();
						}}
						membershipData={membershipData}
					/>
				</Modal>
			)}
		</>
	);
};
